// extracted by mini-css-extract-plugin
export default {"wrapper":"Oz-z","viewport":"Pz-z","container":"Qz-z","slide":"Rz-z"};